<template>
  <div class="bg-gray-10 w-full h-full flex-1 flex flex-col">
    <div class="flex w-full flex-1">
      <TimetableSplitViewEventList />
      <TimetableSplitViewTable />
    </div>
  </div>
</template>

<script>
import TimetableSplitViewTable from '@/components/Timetable/TimetableSplitViewTable'
import TimetableSplitViewEventList from '@/components/Timetable/TimetableSplitViewEventList'

export default {
  name: 'TimetableSplitView',

  components: {
    TimetableSplitViewEventList,
    TimetableSplitViewTable
  }
}
</script>
